import { Router } from '@angular/router';

/**
 * Matches absolute URLs (with a scheme, e.g. `https://`) and protocol-relative
 * URLs (`//host/...`) — i.e. URLs that target a different origin and therefore
 * cannot be handled by the in-app Angular router.
 */
const EXTERNAL_URL = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;

/**
 * Returns `true` when the URL points to an external origin (absolute or
 * protocol-relative), `false` for an in-app (relative) route.
 */
export function isExternalUrl(url: string): boolean {
  return EXTERNAL_URL.test(url);
}

/**
 * Navigates to `url`, supporting both relative and absolute targets:
 * - relative routes are handled by the Angular {@link Router};
 * - absolute / external URLs trigger a full-page navigation.
 *
 * @param url - The destination, relative (`/compare-plans`) or absolute
 *   (`https://example.com/compare-plans`)
 * @param router - Router used for in-app navigation
 * @param document - Document used for full-page navigation to external URLs
 */
export async function redirectToUrl(
  url: string,
  router: Router,
  document: Document,
): Promise<void> {
  if (isExternalUrl(url)) {
    document.location.assign(url);
    return;
  }

  await router.navigateByUrl(url);
}
